import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

/**
 * A no-op logger
 */
var DummyLogger =
/*#__PURE__*/
function () {
  function DummyLogger() {
    _classCallCheck(this, DummyLogger);
  }

  _createClass(DummyLogger, [{
    key: "log",
    value: function log() {}
  }, {
    key: "debug",
    value: function debug() {}
  }, {
    key: "info",
    value: function info() {}
  }, {
    key: "warn",
    value: function warn() {}
  }, {
    key: "error",
    value: function error() {}
  }, {
    key: "time",
    value: function time() {}
  }, {
    key: "timeEnd",
    value: function timeEnd() {}
  }]);

  return DummyLogger;
}();

var LOGGER = new DummyLogger();
/**
 *
 * @param {object} logger the new logger. e.g `console`
 */

export function setLogger() {
  var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DummyLogger();
  LOGGER = logger;
}
export function debug() {
  var _LOGGER;

  return (_LOGGER = LOGGER).debug.apply(_LOGGER, arguments);
}
export function log() {
  var _LOGGER2;

  return (_LOGGER2 = LOGGER).log.apply(_LOGGER2, arguments);
}
export function info() {
  var _LOGGER3;

  return (_LOGGER3 = LOGGER).info.apply(_LOGGER3, arguments);
}
export function warn() {
  var _LOGGER4;

  return (_LOGGER4 = LOGGER).warn.apply(_LOGGER4, arguments);
}
export function error() {
  var _LOGGER5;

  return (_LOGGER5 = LOGGER).error.apply(_LOGGER5, arguments);
}
export function time() {
  var _LOGGER6;

  return (_LOGGER6 = LOGGER).time.apply(_LOGGER6, arguments);
}
export function timeEnd() {
  var _LOGGER7;

  return (_LOGGER7 = LOGGER).timeEnd.apply(_LOGGER7, arguments);
}